module.exports = __webpack_public_path__ + "media/images/sm_icon03-f3f4a48a4a0d0104de2e7dfa6e374b17.png";